import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import { MasquaradeLogin } from 'components/Masquarade'

const UserMasquaradePage: FC = () => {
  return (
    <UserProtectedRoute>
      <MasquaradeLogin />
    </UserProtectedRoute>
  )
}

export default UserMasquaradePage
